import {
  createEditorialClipBinding,
  type EditorialClipBinding,
  type MediaFamily,
  type MediaMember,
} from "@/components/OmniCine/Timeline/MediaUnion";

export type BuildExplicitEditorialClipBindingArgs = {
  clipId: string;
  familyId: string;
  mediaFamilies: MediaFamily[];
  mediaMembers: MediaMember[];
  audioMemberId?: string;
  videoMemberId?: string;
  existingBinding?: EditorialClipBinding | null;
};

export function buildExplicitEditorialClipBinding(
  args: BuildExplicitEditorialClipBindingArgs,
): EditorialClipBinding | null {
  const clipId = String(args.clipId ?? "").trim();
  const familyId = String(args.familyId ?? "").trim();
  if (!clipId || !familyId) return null;

  const family = args.mediaFamilies.find((entry) => entry.id === familyId);
  if (!family) return null;

  return createEditorialClipBinding({
    clipId,
    family,
    mediaMembers: args.mediaMembers,
    audioMemberId: args.audioMemberId,
    videoMemberId: args.videoMemberId,
    source: "explicit",
    existingBinding: args.existingBinding ?? undefined,
  });
}